import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaHome, FaGraduationCap, FaUser, FaImages, FaNewspaper, FaFileAlt, FaCog, FaShieldAlt, FaCode, FaLaptop, FaNetworkWired, FaComments } from "react-icons/fa";

// Comprehensive routes database extracted from App.js
const routes = [
  // Main Pages
  {
    path: "/",
    name: "Home",
    keywords: ["home", "main", "index", "start", "landing", "welcome"],
    category: "Main",
    icon: FaHome
  },
  {
    path: "/about",
    name: "About Us",
    keywords: ["about", "college", "information", "who we are", "institution", "history"],
    category: "About",
    icon: FaUser
  },
  {
    path: "/about/mission",
    name: "Mission & Vision",
    keywords: ["mission", "vision", "goals", "objectives", "purpose", "values"],
    category: "About",
    icon: FaUser
  },
  {
    path: "/about/trustees",
    name: "Advisory Board",
    keywords: ["trustees", "board", "advisory", "leadership", "management", "directors"],
    category: "About",
    icon: FaUser
  },
  {
    path: "/about/terms-conditions",
    name: "Terms and Conditions",
    keywords: ["terms", "conditions", "policy", "legal", "agreement", "rules"],
    category: "About",
    icon: FaFileAlt
  },

  // Main Courses
  {
    path: "/course/information-technology",
    name: "Information Technology",
    keywords: ["information technology", "it", "computer", "technology", "systems", "programming"],
    category: "Courses",
    icon: FaLaptop
  },
  {
    path: "/course/cyber-security",
    name: "Cyber Security",
    keywords: ["cyber", "security", "hacking", "network security", "ethical hacking", "cybersecurity", "protection"],
    category: "Courses",
    icon: FaShieldAlt
  },
  {
    path: "/course/computer-science",
    name: "Computer Science",
    keywords: ["computer science", "cs", "programming", "algorithms", "software", "development"],
    category: "Courses",
    icon: FaCode
  },
  {
    path: "/course/computer-engineering",
    name: "Computer Engineering",
    keywords: ["computer engineering", "hardware", "electronics", "engineering", "systems", "architecture"],
    category: "Courses",
    icon: FaCog
  },
  {
    path: "/course/electronics-telecommunications",
    name: "Electronics & Telecommunications",
    keywords: ["electronics", "telecommunications", "telecom", "communication", "signals", "networks"],
    category: "Courses",
    icon: FaNetworkWired
  },
  {
    path: "/course/business-administration",
    name: "Business Administration",
    keywords: ["business", "administration", "management", "commerce", "enterprise", "corporate"],
    category: "Courses",
    icon: FaGraduationCap
  },
  {
    path: "/course/accountancy",
    name: "Accountancy",
    keywords: ["accountancy", "accounting", "finance", "bookkeeping", "audit", "financial"],
    category: "Courses",
    icon: FaGraduationCap
  },
  {
    path: "/course/travel-tourism-management",
    name: "Travel & Tourism Management",
    keywords: ["travel", "tourism", "hospitality", "management", "tourism", "travel industry"],
    category: "Courses",
    icon: FaGraduationCap
  },
  {
    path: "/course/short-courses",
    name: "Short Courses",
    keywords: ["short courses", "certificates", "training", "skills", "professional development"],
    category: "Courses",
    icon: FaGraduationCap
  },
  {
    path: "/course/professional-courses",
    name: "Professional Courses",
    keywords: ["professional", "courses", "certification", "training", "career", "development"],
    category: "Courses",
    icon: FaGraduationCap
  },

  // IT Programs
  {
    path: "/courses/information-technology/computer-hardware",
    name: "Computer Hardware",
    keywords: ["hardware", "computer hardware", "components", "assembly", "repair", "maintenance"],
    category: "IT Programs",
    icon: FaLaptop
  },
  {
    path: "/courses/information-technology/computer-software",
    name: "Computer Software",
    keywords: ["software", "applications", "programs", "systems", "development", "programming"],
    category: "IT Programs",
    icon: FaCode
  },
  {
    path: "/courses/information-technology/computer-applications",
    name: "Computer Applications",
    keywords: ["applications", "apps", "software", "programs", "computer apps", "desktop"],
    category: "IT Programs",
    icon: FaCode
  },
  {
    path: "/courses/information-technology/networking-system-administration",
    name: "Networking & System Administration",
    keywords: ["networking", "network", "system administration", "admin", "servers", "infrastructure"],
    category: "IT Programs",
    icon: FaNetworkWired
  },
  {
    path: "/courses/information-technology/linux-administration",
    name: "Linux Administration",
    keywords: ["linux", "administration", "unix", "server", "command line", "terminal"],
    category: "IT Programs",
    icon: FaCog
  },
  {
    path: "/courses/information-technology/database-management",
    name: "Database Management",
    keywords: ["database", "sql", "data", "management", "storage", "queries"],
    category: "IT Programs",
    icon: FaCog
  },
  {
    path: "/courses/information-technology/object-oriented-programming-oop",
    name: "Object-Oriented Programming (OOP)",
    keywords: ["oop", "object oriented", "programming", "java", "c++", "python", "classes"],
    category: "IT Programs",
    icon: FaCode
  },
  {
    path: "/courses/information-technology/website-application-development",
    name: "Web Application Development",
    keywords: ["web development", "web apps", "frontend", "backend", "full stack", "javascript"],
    category: "IT Programs",
    icon: FaCode
  },
  {
    path: "/courses/information-technology/cyber-security",
    name: "Cyber Security",
    keywords: ["cyber security", "security", "protection", "hacking", "network security", "firewall"],
    category: "IT Programs",
    icon: FaShieldAlt
  },
  {
    path: "/courses/information-technology/cloud-computing",
    name: "Cloud Computing",
    keywords: ["cloud", "computing", "aws", "azure", "google cloud", "virtualization", "servers"],
    category: "IT Programs",
    icon: FaCog
  },
  {
    path: "/courses/information-technology/system-analysis-design",
    name: "System Analysis & Design",
    keywords: ["system analysis", "design", "requirements", "architecture", "planning", "development"],
    category: "IT Programs",
    icon: FaCog
  },
  {
    path: "/courses/information-technology/adobe-applications",
    name: "Adobe Applications",
    keywords: ["adobe", "photoshop", "illustrator", "premiere", "design", "creative", "graphics"],
    category: "IT Programs",
    icon: FaCode
  },

  // Cyber Security Programs
  {
    path: "/courses/cyber-security/intro-to-cyber-security",
    name: "Introduction to Cyber Security",
    keywords: ["cyber security", "introduction", "basics", "fundamentals", "security concepts"],
    category: "Cyber Security",
    icon: FaShieldAlt
  },
  {
    path: "/courses/cyber-security/network-os-security",
    name: "Network & OS Security",
    keywords: ["network security", "operating system", "os security", "firewall", "network protection"],
    category: "Cyber Security",
    icon: FaShieldAlt
  },
  {
    path: "/courses/cyber-security/cryptography-basics",
    name: "Cryptography Basics",
    keywords: ["cryptography", "encryption", "decryption", "crypto", "security", "algorithms"],
    category: "Cyber Security",
    icon: FaShieldAlt
  },
  {
    path: "/courses/cyber-security/ethical-hacking-pen-testing",
    name: "Ethical Hacking & Penetration Testing",
    keywords: ["ethical hacking", "penetration testing", "pen testing", "hacking", "security testing"],
    category: "Cyber Security",
    icon: FaShieldAlt
  },
  {
    path: "/courses/cyber-security/web-application-security",
    name: "Web Application Security",
    keywords: ["web security", "application security", "web app security", "vulnerabilities", "protection"],
    category: "Cyber Security",
    icon: FaShieldAlt
  },
  {
    path: "/courses/cyber-security/malware-forensics",
    name: "Malware Forensics",
    keywords: ["malware", "forensics", "investigation", "analysis", "threats", "viruses"],
    category: "Cyber Security",
    icon: FaShieldAlt
  },
  {
    path: "/courses/cyber-security/wireless-mobile-security",
    name: "Wireless & Mobile Security",
    keywords: ["wireless security", "mobile security", "wifi", "bluetooth", "mobile devices"],
    category: "Cyber Security",
    icon: FaShieldAlt
  },

  // Computer Science Programs
  {
    path: "/courses/computer-science/programming-fundamentals",
    name: "Programming Fundamentals",
    keywords: ["programming", "fundamentals", "basics", "coding", "algorithms", "logic"],
    category: "Computer Science",
    icon: FaCode
  },
  {
    path: "/courses/computer-science/data-structures-algorithms",
    name: "Data Structures & Algorithms",
    keywords: ["data structures", "algorithms", "programming", "computer science", "optimization"],
    category: "Computer Science",
    icon: FaCode
  },

  // Computer Engineering Programs
  {
    path: "/courses/computer-engineering/digital-electronics",
    name: "Digital Electronics",
    keywords: ["digital electronics", "electronics", "circuits", "hardware", "engineering"],
    category: "Computer Engineering",
    icon: FaCog
  },
  {
    path: "/courses/computer-engineering/computer-architecture",
    name: "Computer Architecture",
    keywords: ["computer architecture", "hardware", "processors", "memory", "systems"],
    category: "Computer Engineering",
    icon: FaCog
  },

  // Other Pages
  {
    path: "/gallery/photos",
    name: "Photo Gallery",
    keywords: ["photos", "gallery", "images", "pictures", "visual", "photography"],
    category: "Gallery",
    icon: FaImages
  },
  {
    path: "/gallery/videos",
    name: "Video Gallery",
    keywords: ["videos", "gallery", "media", "multimedia", "video", "content"],
    category: "Gallery",
    icon: FaImages
  },
  {
    path: "/events",
    name: "All Events",
    keywords: ["events", "calendar", "schedule", "activities", "programs", "functions"],
    category: "Events",
    icon: FaNewspaper
  },
  {
    path: "/news",
    name: "All News",
    keywords: ["news", "updates", "announcements", "information", "latest", "current"],
    category: "News",
    icon: FaNewspaper
  },
  {
    path: "/apply",
    name: "Apply Now",
    keywords: ["apply", "application", "admission", "enroll", "register", "join"],
    category: "Admissions",
    icon: FaFileAlt
  },
  {
    path: "/student-portal",
    name: "Student Portal",
    keywords: ["student portal", "portal", "login", "dashboard", "student", "access"],
    category: "Student",
    icon: FaUser
  },
  {
    path: "/contact",
    name: "Contact Us",
    keywords: ["contact", "reach", "get in touch", "communication", "support", "help"],
    category: "Support",
    icon: FaUser
  },
  {
    path: "/fees",
    name: "Fee Structure",
    keywords: ["fees", "cost", "pricing", "tuition", "payment", "financial"],
    category: "Financial",
    icon: FaFileAlt
  },
  {
    path: "/athletics",
    name: "Athletics",
    keywords: ["athletics", "sports", "fitness", "physical", "games", "activities"],
    category: "Campus Life",
    icon: FaUser
  },
  {
    path: "/campus-tour",
    name: "Campus Tour",
    keywords: ["campus tour", "tour", "visit", "campus", "facilities", "virtual tour"],
    category: "Campus Life",
    icon: FaUser
  },
  {
    path: "/academics",
    name: "Academics",
    keywords: ["academics", "academic", "education", "learning", "curriculum", "programs"],
    category: "Academic",
    icon: FaGraduationCap
  },
  {
    path: "/departments",
    name: "Departments",
    keywords: ["departments", "faculty", "schools", "divisions", "units", "organizations"],
    category: "Academic",
    icon: FaGraduationCap
  },
  {
    path: "/programs",
    name: "Programs",
    keywords: ["programs", "courses", "curriculum", "academic programs", "degrees", "certificates"],
    category: "Academic",
    icon: FaGraduationCap
  },
  {
    path: "/library",
    name: "Library",
    keywords: ["library", "books", "resources", "research", "study", "materials"],
    category: "Resources",
    icon: FaFileAlt
  },
  {
    path: "/services",
    name: "Services",
    keywords: ["services", "support", "help", "assistance", "academic support", "career services"],
    category: "Support",
    icon: FaCog
  },
  {
    path: "/feedback",
    name: "Feedback",
    keywords: ["feedback", "suggestions", "complaints", "reviews", "opinions", "comments", "report", "bug", "improvement"],
    category: "Support",
    icon: FaComments
  },
  {
    path: "/admissions",
    name: "Admissions",
    keywords: ["admissions", "enrollment", "apply", "application", "requirements", "process"],
    category: "Admissions",
    icon: FaFileAlt
  }
];

const SmartSearch = ({ isOpen, onClose, searchTerm, setSearchTerm }) => {
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const resultsRef = useRef(null);

  // Search algorithm with scoring
  const searchRoutes = (query) => {
    if (!query.trim()) {
      setFilteredRoutes([]);
      return;
    }

    const queryLower = query.toLowerCase();
    const results = routes
      .map(route => {
        let score = 0;
        const nameLower = route.name.toLowerCase();
        const pathLower = route.path.toLowerCase();
        const keywordsLower = route.keywords.map(k => k.toLowerCase());

        // Exact name match (highest priority)
        if (nameLower === queryLower) {
          score += 100;
        }
        // Name starts with query
        else if (nameLower.startsWith(queryLower)) {
          score += 80;
        }
        // Name contains query
        else if (nameLower.includes(queryLower)) {
          score += 60;
        }

        // Path contains query
        if (pathLower.includes(queryLower)) {
          score += 40;
        }

        // Keyword matches
        const keywordMatches = keywordsLower.filter(keyword => 
          keyword.includes(queryLower) || queryLower.includes(keyword)
        );
        score += keywordMatches.length * 20;

        // Partial keyword matches
        const partialMatches = keywordsLower.filter(keyword => 
          keyword.split(' ').some(word => word.startsWith(queryLower)) ||
          queryLower.split(' ').some(word => keyword.includes(word))
        );
        score += partialMatches.length * 10;

        return { ...route, score };
      })
      .filter(route => route.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 8);

    setFilteredRoutes(results);
  };

  // Handle search input
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      searchRoutes(searchTerm);
    }, 150);

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (!isOpen) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedIndex(prev => 
          prev < filteredRoutes.length - 1 ? prev + 1 : 0
        );
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedIndex(prev => 
          prev > 0 ? prev - 1 : filteredRoutes.length - 1
        );
        break;
      case 'Enter':
        e.preventDefault();
        if (filteredRoutes[selectedIndex]) {
          handleRouteClick(filteredRoutes[selectedIndex]);
        }
        break;
      case 'Escape':
        onClose();
        break;
      default:
        break;
    }
  };

  // Handle route click
  const handleRouteClick = (route) => {
    navigate(route.path);
    setSearchTerm('');
    onClose();
  };

  // Highlight matching text
  const highlightText = (text, query) => {
    if (!query.trim()) return text;
    
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? (
        <mark key={index} className="bg-yellow-200 text-yellow-900 px-1 rounded">
          {part}
        </mark>
      ) : part
    );
  };

  // Get category color
  const getCategoryColor = (category) => {
    const colors = {
      'Main': 'bg-blue-100 text-blue-800',
      'About': 'bg-purple-100 text-purple-800',
      'Courses': 'bg-green-100 text-green-800',
      'IT Programs': 'bg-indigo-100 text-indigo-800',
      'Cyber Security': 'bg-red-100 text-red-800',
      'Computer Science': 'bg-orange-100 text-orange-800',
      'Computer Engineering': 'bg-teal-100 text-teal-800',
      'Gallery': 'bg-pink-100 text-pink-800',
      'Events': 'bg-yellow-100 text-yellow-800',
      'News': 'bg-gray-100 text-gray-800',
      'Admissions': 'bg-custom-pink text-white',
      'Student': 'bg-blue-100 text-blue-800',
      'Support': 'bg-gray-100 text-gray-800',
      'Financial': 'bg-green-100 text-green-800',
      'Campus Life': 'bg-purple-100 text-purple-800',
      'Academic': 'bg-indigo-100 text-indigo-800',
      'Resources': 'bg-orange-100 text-orange-800'
    };
    return colors[category] || 'bg-gray-100 text-gray-800';
  };

  if (!isOpen) return null;

  return (
    <div className="absolute right-0 top-full mt-2 w-96 bg-white rounded-lg shadow-xl z-50 border border-gray-200">
      <div className="p-4">
        <div className="relative">
          <input
            ref={searchRef}
            type="text"
            placeholder="Search courses, pages, and more..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-custom-pink focus:border-transparent text-sm"
            autoFocus
          />
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>

        <div ref={resultsRef} className="mt-4 max-h-96 overflow-y-auto">
          {filteredRoutes.length > 0 ? (
            <div className="space-y-1">
              {filteredRoutes.map((route, index) => {
                const IconComponent = route.icon;
                return (
                  <div
                    key={route.path}
                    onClick={() => handleRouteClick(route)}
                    className={`flex items-center p-3 rounded-lg cursor-pointer transition-colors ${
                      index === selectedIndex
                        ? 'bg-custom-pink text-white'
                        : 'hover:bg-gray-100'
                    }`}
                  >
                    <div className={`flex-shrink-0 mr-3 ${
                      index === selectedIndex ? 'text-white' : 'text-custom-pink'
                    }`}>
                      <IconComponent className="w-5 h-5" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between">
                        <p className={`text-sm font-medium truncate ${
                          index === selectedIndex ? 'text-white' : 'text-gray-900'
                        }`}>
                          {highlightText(route.name, searchTerm)}
                        </p>
                        <span className={`px-2 py-1 text-xs rounded-full ${
                          index === selectedIndex 
                            ? 'bg-white bg-opacity-20 text-white' 
                            : getCategoryColor(route.category)
                        }`}>
                          {route.category}
                        </span>
                      </div>
                      <p className={`text-xs mt-1 truncate ${
                        index === selectedIndex ? 'text-white text-opacity-80' : 'text-gray-500'
                      }`}>
                        {route.path}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : searchTerm.trim() ? (
            <div className="text-center py-8">
              <FaSearch className="mx-auto text-gray-400 text-2xl mb-2" />
              <p className="text-gray-500 text-sm">No results found for "{searchTerm}"</p>
              <p className="text-gray-400 text-xs mt-1">Try different keywords or check spelling</p>
            </div>
          ) : (
            <div className="text-center py-8">
              <FaSearch className="mx-auto text-custom-pink text-2xl mb-2" />
              <p className="text-gray-500 text-sm">Start typing to search</p>
              <p className="text-gray-400 text-xs mt-1">Find courses, pages, and more</p>
            </div>
          )}
        </div>

        <div className="mt-4 pt-3 border-t border-gray-200">
          <div className="flex items-center justify-between text-xs text-gray-500">
            <span>Press ↑↓ to navigate</span>
            <span>Press Enter to select</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartSearch;